import { useNavigate } from "react-router-dom";
import { useData } from "@/store/DataContext";
import SummaryHero from "./components/SummaryHero";
import StatGrid from "./components/StatGrid";
import ProfitBreakdown from "./components/ProfitBreakdown";
import QuickActions from "./components/QuickActions";
import ExpiringSection from "./components/ExpiringSection";
import MovementRow from "@/components/feature/MovementRow";

export default function Home() {
  const { summary, expiring, timeline, data, loading } = useData();
  const navigate = useNavigate();

  const today = new Date().toLocaleDateString("es-DO", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  if (loading) {
    return (
      <div className="flex h-[60vh] items-center justify-center">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-500" />
      </div>
    );
  }

  return (
    <div className="fr-animate space-y-6">
      <div>
        <p className="text-[13px] capitalize text-foreground-500">{today}</p>
        <h1 className="mt-0.5 text-[22px] font-bold text-foreground-950">Tu resumen de hoy</h1>
      </div>

      <SummaryHero summary={summary} businessName={data.settings.businessName} />

      <ExpiringSection items={expiring} />

      <section>
        <h2 className="mb-3 text-[15px] font-semibold text-foreground-900">Acciones rápidas</h2>
        <QuickActions />
      </section>

      <section>
        <h2 className="mb-3 text-[15px] font-semibold text-foreground-900">Indicadores</h2>
        <StatGrid summary={summary} />
      </section>

      <section>
        <h2 className="mb-3 text-[15px] font-semibold text-foreground-900">Detalle del período</h2>
        <ProfitBreakdown summary={summary} />
      </section>

      <section>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[15px] font-semibold text-foreground-900">Últimos movimientos</h2>
          <button
            type="button"
            onClick={() => navigate("/movimientos")}
            className="text-[13px] font-medium text-primary-700"
          >
            Ver todo
          </button>
        </div>
        <div className="divide-y divide-background-200 overflow-hidden rounded-3xl border border-background-200/70 bg-background-50 shadow-card">
          {timeline.slice(0, 5).map((entry) => (
            <MovementRow key={entry.id} entry={entry} />
          ))}
          {timeline.length === 0 ? (
            <p className="px-4 py-6 text-center text-[13px] text-foreground-500">
              Aún no hay movimientos registrados.
            </p>
          ) : null}
        </div>
      </section>
    </div>
  );
}